module.exports = __webpack_public_path__ + "img/upinfo.f8339c4d.svg";